
import React, {useState} from 'react';
import {Link} from "react-router-dom";

import {_printNumber} from '../../helpers/helpers.js'

import {CommonResponseHeadersPageResult} from '../../../../server/routes/main.js'

interface ResponseHeadersProps {
    server: string;
    pageData: unknown;
}

interface ComponentProps {
    props: CommonResponseHeadersPageResult;
}

interface HeaderData {
    HeaderName: string;
    HeaderMoniker: string;
    HeaderValue: string;
    HeaderPercentage: string;
    DomainCount: number;
}

interface HeaderRowProps {
    header: HeaderData;
}

function printPercent(per: string, value: number): string {
    if (value > 0 && per == '0.00'){
        return '<0.01';
    }
    return per+'%';
}


export default function ResponseHeaders({server, pageData}: ResponseHeadersProps) {

    const typedPageData = pageData as CommonResponseHeadersPageResult;
	let [data, setData] = useState(typedPageData);

    return (
        <>
            <section className="section section-lg text-center">
                <div className="container">
                    <ResponseHeaderInfo props={data} />
                    <HeadersTable props={data}/>
                </div>
            </section>
        </>
	)
}

function ResponseHeaderInfo({props}: ComponentProps) {
    return (<>
    
    <div className="text-center">
                    <h2>HTTP Response Headers</h2>
                    &nbsp;
                </div>
                <div className="layout-bordered-1">
                    HTTP headers are part of the HTTP request and response. The headers are designed to pass an additional information about request and response between the server and the client.
                    Neither request nor respone headers are shown by browser and usually hidden from the user.
                    The headers can be standard and defined as part of HTTP standard or custom defined by web application developers.
                    The HTTP headers are separated by CRLF line break pair from each other and from the body. Each header consists of header name and the value separated by a colon.
                    &nbsp;
                </div>
                <div className="layout-bordered-1">&nbsp;</div>
                <div className="layout-bordered-1">&nbsp;</div>
    </>)
}

function HeadersTable({props}: ComponentProps) {

    return (<>
        <div className="layout-bordered-1">&nbsp;</div>
        <div className="layout-bordered-1">&nbsp;</div>
        <div className="layout-bordered-1">&nbsp;</div>
        <h4>Common response headers</h4>
        <br/>    

        <table 
            className="table table-striped table-bordered table-hover"
            role="grid"   
            style={{textAlign: 'left', tableLayout: 'fixed', width: '100%', wordWrap: 'break-word'}}
        >
            <thead className="wts-table-header">
                <tr role="row">
                    <th style={{width: '130px'}}>Name</th>
                    <th style={{width: '60%'}}>Sample value</th>
                    <th style={{width: '80px'}}>Occurence</th>
                    <th style={{width: '80px'}}>Domains</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.CommonHeaders.map((header: HeaderData, indexKey: number) => 
                        <HeaderRow header={header} key={indexKey}/>
                    )
                }
            </tbody>
        </table>    
    </>)
}

function HeaderRow({header}: HeaderRowProps) {
    return (

        <tr role="row">
            <td>
                <Link 
                    to={`/response-header/${header.HeaderMoniker}`}
                    className="link-hover" 
                >
                    {header.HeaderName}
                </Link>
            </td>
            <td>
                {header.HeaderValue}
            </td>
            <td>
                {printPercent(header.HeaderPercentage, 1)}
            </td>
            <td>
                {_printNumber(header.DomainCount)}
            </td>
        </tr>
    )
}